import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ReactLenis } from 'lenis/react';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Categories from './pages/Categories';
import ProductDetail from './pages/ProductDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Navbar from './components/Navbar';
import OfferBar from './components/OfferBar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CartDrawer from './components/CartDrawer';
import FreePosterPicker from './components/FreePosterPicker';
import ScrollLock from './components/ScrollLock';
import BackButton from './components/BackButton';
import { CartProvider } from './lib/CartContext';
import { Toaster } from 'sonner';
import { supabase } from './lib/supabase';
import { adminSignOut } from './lib/api';

function App() {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  // Admin session is managed by Supabase Auth (persists across reloads).
  useEffect(() => {
    // Clear tokens left over from the old Emergent backend.
    try {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_email');
    } catch {
      /* ignore */
    }
    const toUser = (session) =>
      session?.user ? { email: session.user.email, token: session.access_token } : null;

    supabase.auth.getSession().then(({ data }) => {
      setUser(toUser(data.session));
      setAuthReady(true);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(toUser(session));
      setAuthReady(true);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const handleLogin = (session) => {
    if (session?.user) setUser({ email: session.user.email, token: session.access_token });
  };

  const handleLogout = async () => {
    await adminSignOut();
    setUser(null);
  };

  return (
    <ReactLenis root>
      <BrowserRouter>
        <CartProvider>
          <div className="App bg-background min-h-screen flex flex-col">
            <Navbar user={user} onLogout={handleLogout} />
            <OfferBar />
            <main className="flex-1 pt-[40px] sm:pt-[44px]">
              <BackButton />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/admin" element={<AdminLogin onLogin={handleLogin} />} />
                <Route path="/admin/dashboard" element={<AdminDashboard user={user} authReady={authReady} />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
            <CartDrawer />
            <FreePosterPicker />
            <ScrollLock />
            <Toaster position="top-right" theme="dark" />
          </div>
        </CartProvider>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
